import React, { useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import ShowAreaIcon from "assets/svgIcons/ShowAreaIcon";
import ShowCenterIcon from "assets/svgIcons/ShowCenterIcon";
import ZoomIcon from "assets/svgIcons/ZoomIcon";
import ZoomOutIcon from "assets/svgIcons/ZoomOutIcon";
import RefreshIcon from "assets/svgIcons/ResendIcon";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useHookstate } from "@hookstate/core";
import {
  COMMON_SERVICES,
  headersConfigData,
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import MenuItem from "@mui/material/MenuItem";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import Select from "@mui/material/Select";
import {
  getSiteSetupApiCall
} from "redux/reduxToolkitServices/_commonApiCalls/api";
import {
  setAreaFilterData
} from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import { SiteSetupAction, MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { Tooltip, CircularProgress } from "@mui/material";
import VerifyPopup from "./VerifyPopup";
import RadioCheckIcon from "assets/svgIcons/RadioCheckedIcon";
import RadioUncheckIcon from "assets/svgIcons/RadioUncheckIcon";
import { SelectTagCar } from "commonComponents/SideNav/subSectionNav/Map/MapStyled";
import _ from "lodash";
import moment from "moment";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LoadPreviewImage from "./LoadPreviewImage";
import { settingsPoITypes } from "constant";

export const SiteSetupWindow = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { siteSetupSection } = useHookstate(MAP_GLOBAL_STATES);
  const {
    showAreas,
    showCenterOfGreens,
    showTeeMarkers,
    showAll,
    hideAll,
    showPointsOfInterest,
    teesBtn,
    gmsBtn,
    fwysBtn,
    imageUrl,
    imageHoleNo,
    courseNo,
    typeHole,
    holeNum,
    stgsBtn,
    extsBtn,
    holeView,
    holeChange,
    holeSelected,
    showSiteData,
    poiSiteData,
    teeSiteData,
    isPreviewImageZoomed,
  } = useHookstate(SiteSetupAction);

  const [publishOvernightToCars, setPublishOvernightToCars] = useState(false);
  const [pendingPublishOvernightToCars, setPendingPublishOvernightToCars] = useState(null);
  const [publishOvernightToCarsBtn, setPublishOvernightToCarsBtn] = useState(false);
  const [sitedataLastUpdate, setSitedataLastUpdate] = useState(null);
  const [POILastUpdate, setPOILastUpdate] = useState(null);
  const [teesLastUpdate, setTeesLastUpdate] = useState(null);
  const [tees, setTees] = useState(true);
  const [checkMeadowsData, setCheckMeadowsData] = useState([]);
  const [gms, setGms] = useState(true);
  const [fwys, setFwys] = useState(true);
  const [imageZoom, setImageZoom] = useState(false);
  const [exts, setExts] = useState(true);
  const [stgs, setStgs] = useState(true);
  const [courseName, setCourseName] = useState(1);
  const [holeCount, setHoleCount] = useState(null);
  const [holeNo, setHoleNo] = useState(1);
  const [holeType, setHoleType] = useState(1);
  const [siteSetupState, setSiteSetupState] = useState([]);
  const [btnLocal, setBtnLocal] = useState({});
  const [isAllChecked, setIsAllChecked] = useState(true);
  const [verifyPopupOpen, SetVerifyPopupOpen] = useState(false);
  const [verifyText, setVerifyText] = useState("");
  const [verifyTitle, setVerifyTitle] = useState("");
  const [missingData] = useState([]);
  const [verifyLoding, setVerifyLoding] = useState(false);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const {
    siteSettingsData,
    siteSetupData,
    mapInformationData,
    mapInformationStatus
  } = useSelector((state) => state.commonReducers) || [];

  let optionsCPOData = [];
  let newArray = [];

  useEffect(() => {
    setPublishOvernightToCarsBtn(showSiteData.get() || poiSiteData.get() || teeSiteData.get());

    if (siteSettingsData && Object.keys(siteSettingsData)?.length > 0) {
      setSitedataLastUpdate(siteSettingsData?.SiteDataVersionDate);
      setPOILastUpdate(siteSettingsData?.POIsVersionDate);
      setTeesLastUpdate(siteSettingsData?.TeeMarkersVersionDate);
    }
  }, [siteSettingsData, showSiteData.get(), poiSiteData.get(), teeSiteData.get(), siteId.get()]);

  useEffect(() => {
    if (!showAreas.get() && !showTeeMarkers.get() && !showPointsOfInterest.get() && !showCenterOfGreens.get()) {
      hideAll.set(true);
    }
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    let temp = localStorage.getItem("btnLocal");

    let BtnLocalTemp = {};
    temp = JSON.parse(temp);
    if (temp && "tees" in temp) {
      teesBtn.set(temp.tees);
      BtnLocalTemp = { ...BtnLocalTemp, tees: temp.tees };
    } else BtnLocalTemp = { ...BtnLocalTemp, tees: teesBtn.get() };

    if (temp && "gms" in temp) {
      gmsBtn.set(temp.gms);
      BtnLocalTemp = { ...BtnLocalTemp, gms: temp.gms };
    } else BtnLocalTemp = { ...BtnLocalTemp, gms: gmsBtn.get() };

    if (temp && "fwys" in temp) {
      fwysBtn.set(temp.fwys);
      BtnLocalTemp = { ...BtnLocalTemp, fwys: temp.fwys };
    } else BtnLocalTemp = { ...BtnLocalTemp, fwys: fwysBtn.get() };

    if (temp && "exts" in temp) {
      extsBtn.set(temp.exts);
      BtnLocalTemp = { ...BtnLocalTemp, exts: temp.exts };
    } else BtnLocalTemp = { ...BtnLocalTemp, exts: extsBtn.get() };

    if (temp && "stgs" in temp) {
      stgsBtn.set(temp.stgs);
      BtnLocalTemp = { ...BtnLocalTemp, stgs: temp.stgs };
    } else BtnLocalTemp = { ...BtnLocalTemp, stgs: stgsBtn.get() };
    setBtnLocal(BtnLocalTemp);
  }, []);

  useEffect(() => {
    if (siteSetupData && Object.keys(siteSetupData).length > 0) {
      setSiteSetupState([siteSetupData]);
    }
  }, [siteSetupData]);

  useEffect(() => {
    initCPOData();
    addToCheckMeadow();
    if (siteSettingsData.SiteDataVersionDate === null) showSiteData.set(true);
    if (siteSettingsData.POIsVersionDate === null) poiSiteData.set(true);
    if (siteSettingsData.TeeMarkersVersionDate === null) teeSiteData.set(true);
  }, [siteSettingsData]);

  useEffect(() => {
    if (courseNo.get() !== "") {
      if (courseNo.get())
        courseNameHandleChange(courseNo.get());

      if (typeHole.get() === settingsPoITypes.hole) {
        setHoleType(settingsPoITypes.approach);
      } else {
        setHoleType(settingsPoITypes.hole)
      }

      setHoleNo(holeNum.get());
    }
  }, [courseNo.get(), typeHole.get(), holeNum.get()]);

  function disAbleCPOnly() {
    let i;
    for (i = 0; i < checkMeadowsData.length; i++) {
      for (let j = 0; j < checkMeadowsData[i].Holes.length; j++) {
        checkMeadowsData[i].Holes[j].IsEnabled = false;
      }
    }
  }

  function enableCPOnly() {
    let i;
    for (i = 0; i < checkMeadowsData.length; i++) {
      for (let j = 0; j < checkMeadowsData[i].Holes.length; j++) {
        checkMeadowsData[i].Holes[j].IsEnabled = true;
      }
    }
  }

  let cpoHole = function () {
    this.Course = null;
    this.Hole = null;
    this.ZoneExists = null;
    this.IsEnabled = null;
  };

  let cpoCourse = function () {
    this.Number = null;
    this.Name = null;
    this.HoleCount = null;
    this.IsSelected = false;
    this.Holes = [];
  };

  const setHoleSelectionData = () => {
    showAll.set(false);
    const needFilterFor = [
      "HoleAreas",
      "HoleDatas",
      "PointsOfInterest",
      "SiteAreas",
      "TeeMarkers",
    ];
    let filterData = [];
    var temp = { ...siteSetupState[0] };
    needFilterFor.map((data) => {
      temp[data] = [];
    });

    let allUnchecked = true;
    let allChecked = true;

    checkMeadowsData.map((courseArrMap) => {
      courseArrMap.Holes.map((holeArrMap) => {
        if (holeArrMap.IsEnabled) {
          needFilterFor.map((data) => {
            filterData = siteSetupState?.length > 0 &&
              siteSetupState[0]?.[data]?.filter(
                (items) =>
                  items.Course === courseArrMap.Number &&
                  items.Hole === holeArrMap.Hole
              );
            if (filterData && filterData.length && filterData.length > 0)
              temp[data] = [...temp[data], ...filterData];
            if (holeArrMap.IsEnabled) allUnchecked = false;
          });
        } else allChecked = false;
      });
    });

    if (allUnchecked) hideAll.set(true);
    else hideAll.set(false);
    setIsAllChecked(allChecked);
    temp.SiteAreas = siteSetupState[0].SiteAreas;
    dispatch(setAreaFilterData(temp));
  }

  function toggleHole(hole) {
    if (hole) {
      hole.IsEnabled = !hole.IsEnabled;
      setHoleSelectionData();
      holeView.set(true);
      holeChange.set(true);
      holeSelected.set(hole);
    } else {
      alert(
        t("No_Cart-path_Only_Action_Zones_have_been_assigned_to_this_hole")
      );
    }
  }

  async function initCPOData() {
    try {
      let courseData = siteSettingsData && siteSettingsData?.Courses;

      for (let i = 0; i < courseData.length; i++) {
        let c = new cpoCourse();
        c.Number = courseData[i].Number;
        c.Name = courseData[i].Name;
        c.HoleCount = courseData[i].HoleCount;
        for (let y = 0; y < c.HoleCount; y++) {
          let h = new cpoHole();
          h.Course = c.Number;
          h.Hole = y + 1;
          h.ZoneExists = false;
          h.IsEnabled = true;
          c.Holes.push(h);
        }
        optionsCPOData.push(c);
      }

      newArray = [...optionsCPOData];
    } catch (error) { }
  }

  function handleCheckboxChange(e) {
    if (e.target.name === "unselected") {
      holeChange.set(false);
      hideAll.set(true);
      disAbleCPOnly();
      setHoleSelectionData();
    } else {
      holeChange.set(false);
      hideAll.set(false);
      showAll.set(false);
      setIsAllChecked(true);
      if (e.target.checked) {
        enableCPOnly();
      }

      dispatch(setAreaFilterData(siteSetupState[0]));
      holeView.set(false);
    }
  }

  const reloadFunc = () => {
    var holeAreaType = {
      Tee: 0,
      Fairway: 1,
      Green: 2,
      Extents: 3,
    };
    dispatch(
      COMMON_SERVICES.getMapInformationServices(
        courseNo.get(),
        imageHoleNo.get(),
        holeAreaType.Green === 2 ? 3 : 2,
        siteId.get()
      )
    );
  }

  const SiteName = siteSettingsData && siteSettingsData?.Courses?.filter((item) => item.Number === courseNo.get());

  const addToCheckMeadow = useCallback(() => {
    setCheckMeadowsData(newArray);
  }, [newArray]);

  const courseNameHandleChange = (e) => {
    setCourseName(e?.target ? e.target.value : e);
    let data = siteSettingsData.Courses;
    let obj = data.find((o) => (o.Number === e?.target ? e.target.value : e));
    if (obj && obj !== undefined && obj.HoleCount) {
      let holeNumber = obj.HoleCount;
      setHoleCount(holeNumber);
    }
  }

  const holeNoHandleChange = (e) => {
    setHoleNo(e.target.value);
  }

  const holeTypeHandleChange = (e) => {
    setHoleType(e.target.value);
  }

  const loadFunc = () => {
    dispatch(
      COMMON_SERVICES.getMapInformationServices(
        courseName,
        holeNo,
        holeType === 2 ? 3 : 2,
        siteId.get()
      )
    );
    typeHole.set(holeType)
  }

  const siteData = () => {
    dispatch(COMMON_SERVICES.setSiteSetupServices(siteId.get())).then((res) => {
      if (res) {
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        showSiteData.set(false);
      }
    });
  }

  const poiData = () => {
    dispatch(COMMON_SERVICES.setPioSetupServices(siteId.get())).then((res) => {
      if (res) {
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        poiSiteData.set(false);
      }
    });
  }

  const teesData = () => {
    dispatch(COMMON_SERVICES.setTeeSetupServices(siteId.get())).then((res) => {
      if (res) {
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        teeSiteData.set(false);
      }
    });
  }

  const publishOvernight = () => {
    setPublishOvernightToCars(true);
    setPublishOvernightToCarsBtn(false);
    dispatch(COMMON_SERVICES.setPublishSetupServices(siteId.get())).then(
      (res) => {
        if (res) {
          setPendingPublishOvernightToCars(res);
        }
      }
    );
  }

  var holeAreaType = {
    Tee: 0,
    Fairway: 1,
    Green: 2,
    Extents: 3,
  };

  var MaxPayLoadBytes = 1400;

  const convIntToRGB = (c) => {
    var rgb = "ffffff";
    // convert the signed int to an unsigned int
    c = c >>> 0;
    // convert to HEX and get the last 6 chars for the RGB value
    if (c) rgb = c.toString(16).substr(-6);
    return rgb;
  };

  async function verifySiteData() {
    setVerifyLoding(true);

    await getSiteSetupApiCall(headersConfigData, siteId.get())
      .then((response) => response.json())
      .then((data) => {
        if (data) {

          checkSiteSetup(data);
          if (missingData.length > 0) {
            let missingDataPoints = (
              <div>
                {missingData.map((item) => {
                  return <div>{item}</div>;
                })}
              </div>
            );
            setVerifyTitle("Missing/Incorrect Data");
            setVerifyText(missingDataPoints);

            missingData.length = 0;
            //  });
          } else {
            setVerifyTitle("Verified");
            setVerifyText("All Site Data has been Setup");
          }
        } else {
          setVerifyTitle("Missing");
          setVerifyText("'No Site Data has been Setup', 'Missing'");
        }
      });

    SetVerifyPopupOpen(true);

    setVerifyLoding(false);
  }

  function checkSiteSetup(sData) {
    var tCourse = {};
    var tHole = 0;
    var tHolesInCourse = 0;

    //Check Site Areas
    if (sData.SiteAreas.length === 0) {
      missingData.push("No staging areas set.");
    }

    // Check All Other Site Setup Data
    for (var i = 0; i < siteSettingsData.Courses.length; i++) {
      tCourse = siteSettingsData.Courses[i];
      tHolesInCourse = tCourse.HoleCount;

      for (var j = 0; j < tHolesInCourse; j++) {
        tHole = j + 1;
        checkHoleAreas(sData.HoleAreas, tHole, tCourse);
        checkTeeMarkers(
          sData.TeeMarkers,
          sData.TeeMarkerSettings,
          tHole,
          tCourse
        );
        checkCOGs(sData.HoleDatas, tHole, tCourse);
      }
    }

    checkG2AreaPayloadSizes(sData);
  }

  function checkHoleAreas(tHoleAreas, tHole, tCourse) {
    var tText = "";
    var tHoleAreasHole = _.filter(tHoleAreas, {
      Course: tCourse.Number,
      Hole: tHole,
    });
    if (tHoleAreasHole.length) {
      var hasTeeAreas = _.some(tHoleAreasHole, { Type: holeAreaType.Tee });
      var hasFairwayAreas = _.some(tHoleAreasHole, {
        Type: holeAreaType.Fairway,
      });
      var hasGreenAreas = _.some(tHoleAreasHole, { Type: holeAreaType.Green });
      var hasExtentsAreas = _.some(tHoleAreasHole, {
        Type: holeAreaType.Extents,
      });
      if (
        !hasTeeAreas ||
        !hasFairwayAreas ||
        !hasGreenAreas ||
        !hasExtentsAreas
      ) {
        if (siteSettingsData.Courses.length > 1) {
          tText += tCourse.Name + " ";
        }
        tText += "Hole " + tHole + " is missing Hole Areas:";
        if (!hasTeeAreas) {
          tText += " Tee ";
        }
        if (!hasFairwayAreas) {
          tText += " Fairway ";
        }
        if (!hasGreenAreas) {
          tText += " Green ";
        }
        if (!hasExtentsAreas) {
          tText += " Extents  ";
        }
        missingData.push(tText);
      }
    } else {
      if (siteSettingsData.Courses.length > 1) {
        tText += tCourse.Name + " ";
      }
      tText +=
        "Hole " + tHole + " is missing Hole Areas: Tee Fairway Green Extents ";
      missingData.push(tText);
    }
  }

  function checkTeeMarkers(tTeeMarkers, tTeeMarkerSettings, tHole, tCourse) {
    var anyMissing = [];
    var tSettings = siteSetupData.UsingSharedTeeSettings
      ? tTeeMarkerSettings
      : _.filter(tTeeMarkerSettings, { CourseNumber: tCourse.Number });
    if (tSettings) {
      tSettings.forEach(function (ts) {
        if (
          !_.some(tTeeMarkers, {
            Course: tCourse.Number,
            Hole: tHole,
            TeeMarkerSettingId: ts.Id,
          })
        ) {
          anyMissing.push({
            Course: tCourse.Name,
            Hole: tHole,
            Name: ts.Name,
            Color: ts.ColorRGB,
          });
        }
      });
    }

    if (anyMissing.length) {
      anyMissing.forEach(function (m) {
        var tText = "";
        if (siteSettingsData.Courses.length > 1) {
          tText += m.Course + " ";
        }
        tText +=
          "Hole " +
          m.Hole +
          " is missing tee marker. Setting Name: " +
          m.Name +
          ", Color: " +
          convIntToRGB(m.Color).toUpperCase();
        missingData.push(tText);
      });
    }
  }

  function checkCOGs(tHoleDatas, tHole, tCourse) {
    var cogNotSet = _.some(tHoleDatas, function (hd) {
      return (
        hd.Course === tCourse.Number &&
        hd.Hole === tHole &&
        hd.CogLat === 0 &&
        hd.CogLon === 0
      );
    });
    if (cogNotSet) {
      var tText = "";
      if (siteSettingsData.Courses.length > 1) {
        tText += tCourse.Name + " ";
      }
      tText += "Hole " + tHole + " Center of Green is not set.";
      missingData.push(tText);
    }
  }

  function checkG2AreaPayloadSizes(sData) {
    var course = {};

    // for (var c = 0; c < courseData().length; c++) {
    for (var c = 0; c < siteSettingsData.Courses.length; c++) {
      var teeBytes = 0;
      var fairwayBytes = 0;
      var greenBytes = 10; // 10 byte overhead in AreaDataPayload

      course = siteSettingsData.Courses[c];
      for (var hole = 1; hole <= course.HoleCount; hole++) {
        var teeAreas = _.filter(sData.HoleAreas, {
          Course: course.Number,
          Hole: hole,
          Type: holeAreaType.Tee,
        }); // get tee areas for this hole
        var fwAreas = _.filter(sData.HoleAreas, {
          Course: course.Number,
          Hole: hole,
          Type: holeAreaType.Fairway,
        }); // get fairway areas for this hole
        var greenAreas = _.filter(sData.HoleAreas, {
          Course: course.Number,
          Hole: hole,
          Type: holeAreaType.Green,
        }); // get green areas for this hole

        teeBytes += teeAreas.length * 2 + 2;
        fairwayBytes += fwAreas.length * 2 + 2;
        greenBytes += greenAreas.length * 2 + 2; // 2 bytes per hole, plus 2 bytes per area

        for (var i = 0; i < teeAreas.length; i++)
          teeBytes += teeAreas[i].Polygon.length * 8; // 8 bytes per vertex

        for (var i = 0; i < fwAreas.length; i++)
          fairwayBytes += fwAreas[i].Polygon.length * 8; // 8 bytes per vertex

        for (var i = 0; i < greenAreas.length; i++)
          greenBytes += greenAreas[i].Polygon.length * 8; // 8 bytes per vertex
      }
    }

    if (
      teeBytes > MaxPayLoadBytes ||
      fairwayBytes > MaxPayLoadBytes ||
      greenBytes > MaxPayLoadBytes
    ) {
      if (teeBytes > MaxPayLoadBytes)
        missingData.push(
          "Too many TEE area points for G2 (payload = " +
          teeBytes +
          ", max = " +
          MaxPayLoadBytes +
          ")"
        );
      if (fairwayBytes > MaxPayLoadBytes)
        missingData.push(
          "Too many FAIRWAY area points for G2 (payload = " +
          fairwayBytes +
          ", max = " +
          MaxPayLoadBytes +
          ")"
        );
      if (greenBytes > MaxPayLoadBytes)
        missingData.push(
          "Too many GREEN area points for G2 (payload = " +
          greenBytes +
          ", max = " +
          MaxPayLoadBytes +
          ")"
        );
      missingData.push(
        "--- You need to reduce the number of points in area polygons"
      );
    }
  }

  const handleShowTees = () => {
    let teesTemp = !teesBtn.get();
    setTees(!tees);
    teesBtn.set(!teesBtn.get());
    setBtnLocal({ ...btnLocal, tees: teesTemp });
    let temp = { ...btnLocal, tees: teesTemp };
    localStorage.setItem("btnLocal", JSON.stringify(temp));
  }

  const handleShowGrns = () => {
    let gmsTemp = !gmsBtn.get();
    setGms(!gms);
    gmsBtn.set(!gmsBtn.get());
    setBtnLocal({ ...btnLocal, gms: gmsTemp });
    let temp = { ...btnLocal, gms: gmsTemp };
    localStorage.setItem("btnLocal", JSON.stringify(temp));
  }

  const handleShowFwys = () => {
    let fwysTemp = !fwysBtn.get();
    setFwys(!fwys);
    fwysBtn.set(!fwysBtn.get());
    setBtnLocal({ ...btnLocal, fwys: fwysTemp });
    let temp = { ...btnLocal, fwys: fwysTemp };
    localStorage.setItem("btnLocal", JSON.stringify(temp));
  }

  const handleShowExts = () => {
    let extsTemp = !extsBtn.get();
    setExts(!exts);
    extsBtn.set(!extsBtn.get());
    setBtnLocal({ ...btnLocal, exts: extsTemp });
    let temp = { ...btnLocal, exts: extsTemp };
    localStorage.setItem("btnLocal", JSON.stringify(temp));
  }

  const handleShowStgs = () => {
    let stgsTemp = !stgsBtn.get();
    setStgs(!stgs);
    stgsBtn.set(!stgsBtn.get());
    setBtnLocal({ ...btnLocal, stgs: stgsTemp });
    let temp = { ...btnLocal, stgs: stgsTemp };
    localStorage.setItem("btnLocal", JSON.stringify(temp));
  }

  return (
    <SelectTagCar className={imageZoom ? "site-setup zoom" : "site-setup"}>
      {siteSetupSection.get() && (
        <>
          <div className="all-data">
            {!imageZoom ? (
              <>
                {showAreas.get() ? (
                  <>
                    <div className="heading">{t("Show_Areas")}</div>
                    <div className="filter-btn">
                      <button onClick={handleShowTees} className={teesBtn.get() ? "selected" : ""}>
                        Tees
                      </button>
                      <button onClick={handleShowGrns} className={gmsBtn.get() ? "selected" : ""}>
                        Grns
                      </button>
                      <button onClick={handleShowFwys} className={fwysBtn.get() ? "selected" : ""}>
                        Fwys
                      </button>
                      <button onClick={handleShowExts} className={extsBtn.get() ? "selected" : ""}>
                        Exts
                      </button>
                      <button onClick={handleShowStgs} className={stgsBtn.get() ? "selected" : ""}>
                        Stgs
                      </button>
                    </div>
                  </>
                ) : null}

                <Holes className="site-setup-holes">
                  <p>{t("Holes")}</p>
                  <FormControl>
                    <RadioGroup row value={hideAll.get() ? "hideAll" : isAllChecked ? "viewAll" : null}
                      defaultValue={hideAll.get() ? "hideAll" : "viewAll"}
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="viewAll"
                        name="selected"
                        onClick={handleCheckboxChange}
                        control={
                          <Radio
                            size="small"
                            icon={<RadioUncheckIcon width={15} height={15} />}
                            checkedIcon={
                              <RadioCheckIcon width={15} height={15} />
                            }
                          />
                        }
                        label={t("View_All")}
                      />
                      <FormControlLabel
                        value="hideAll"
                        name="unselected"
                        onClick={handleCheckboxChange}
                        control={
                          <Radio
                            size="small"
                            icon={<RadioUncheckIcon width={15} height={15} />}
                            checkedIcon={
                              <RadioCheckIcon width={15} height={15} />
                            }
                          />
                        }
                        label={t("Hide_All")}
                      />
                    </RadioGroup>
                  </FormControl>
                </Holes>
                <HoleNumber>
                  {checkMeadowsData?.map((c, i) => (
                    <div key={i}>
                      <p key={i + 1}>{c?.Name}</p>
                      {c?.Holes.map((h) => {
                        return (
                          <button key={h.Hole} className={h.IsEnabled ? "active" : "deactive"} onClick={() => toggleHole(h)}>
                            {h.Hole}
                          </button>
                        );
                      })}
                    </div>
                  ))}
                </HoleNumber>

                <SendData>
                  <p className="send-heading">{t("Send")}</p>
                  <div className="data-btn-wrapper">
                    <Tooltip
                      title={showSiteData.get() ? t("Send_SiteData_to_Cars") :
                        sitedataLastUpdate ? `Last sent : ${moment(sitedataLastUpdate + "Z").utc().format("Do MMMM YYYY, HH:mm UTC")}` : ""}
                      arrow
                    >
                      <span>
                        <Button
                          variant="contained"
                          disabled={!showSiteData.get()}
                          onClick={siteData}
                          className={
                            showSiteData.get()
                              ? "send-data-btn "
                              : "send-data-btn deactive"
                          }
                        >
                          <ShowAreaIcon color="var(--theme-text)" />
                          <ShowCenterIcon color="var(--theme-text)" />
                          {t("Site_data")}
                        </Button>
                      </span>
                    </Tooltip>
                    <Tooltip
                      title={poiSiteData.get() ? t("Send_POIs_to_Cars") :
                        POILastUpdate ? `Last sent : ${moment(POILastUpdate + "Z").utc().format("Do MMMM YYYY, HH:mm UTC")}` : ""}
                      arrow
                    >
                      <span>
                        <Button
                          variant="contained"
                          onClick={poiData}
                          disabled={!poiSiteData.get()}
                          className={
                            poiSiteData.get()
                              ? "send-data-btn "
                              : "send-data-btn deactive"
                          }
                        >
                          {t("POIs")}
                        </Button>
                      </span>
                    </Tooltip>
                    <Tooltip
                      title={teeSiteData.get() ? t("Send_TeeMarkers_to_Cars") :
                        teesLastUpdate ? `Last sent : ${moment(teesLastUpdate + "Z").utc().format("Do MMMM YYYY, HH:mm UTC")}` : ""}
                      arrow
                    >
                      <span>
                        <Button
                          variant="contained"
                          onClick={teesData}
                          disabled={!teeSiteData.get()}
                          className={
                            teeSiteData.get()
                              ? "send-data-btn "
                              : "send-data-btn deactive"
                          }
                        >
                          {t("Tees")}
                        </Button>
                      </span>
                    </Tooltip>
                    <Tooltip title={t("Publish_all_data_overnight")} arrow>
                      <span>
                        <Button
                          variant="contained"
                          onClick={() => publishOvernight()}
                          disabled={!publishOvernightToCarsBtn}
                          className={
                            publishOvernightToCarsBtn
                              ? "send-data-btn publish-car"
                              : "send-data-btn deactive publish-car"
                          }
                        >
                          {t("Publish_overnight_to_cars")}
                        </Button>
                      </span>
                    </Tooltip>
                    {pendingPublishOvernightToCars && (
                      <p style={{ fontSize: "13px" }}>
                        Pending publish:
                        {moment(pendingPublishOvernightToCars).utc().format("Do MMMM YYYY, HH:mm UTC")}
                      </p>
                    )}
                    <Dialog
                      aria-labelledby="draggable-dialog-title"
                      open={publishOvernightToCars}
                      onClose={() => setPublishOvernightToCars(!publishOvernightToCars)}
                    >
                      <DialogTitle
                        style={{ cursor: "move" }}
                        id="draggable-dialog-title"
                      >
                        Scheduled site data publishing
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Site data will be published at midnight site time.
                        </DialogContentText>
                      </DialogContent>

                      <DialogActions>
                        <Button
                          onClick={() => {
                            setPublishOvernightToCars(false);
                          }}
                        >
                          {t("Ok")}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </SendData>
                <VerifySiteSetup>
                  <Button variant="outlined" onClick={() => verifySiteData()}>
                    {t("Verify_Site_Setup_is_Complete")}
                    {verifyLoding && (
                      <CircularProgress size={10} style={{ color: "white" }} />
                    )}
                  </Button>
                </VerifySiteSetup>
              </>
            ) : null}

            {imageHoleNo.get() && imageHoleNo.get() !== undefined ? (
              <Preview>
                <div className="text-data">
                  <div style={{ flex: 1 }}>
                    {imageZoom ? (
                      <ZoomPreviewData>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={courseName}
                            defaultValue={courseName}
                            onChange={courseNameHandleChange}
                          >
                            {siteSettingsData &&
                              siteSettingsData?.Courses?.map((item) => (
                                <MenuItem
                                  key={item?.Number}
                                  value={item?.Number}
                                >
                                  {item?.Name}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                        <FormControl>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={holeNo}
                            defaultValue={holeNo}
                            onChange={holeNoHandleChange}
                          >
                            {holeCount &&
                              [...Array(holeCount)].map(
                                (elementInArray, index) => (
                                  <MenuItem key={index} value={index + 1}>
                                    {" "}
                                    {index + 1}{" "}
                                  </MenuItem>
                                )
                              )}
                          </Select>
                        </FormControl>
                        <FormControl>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={holeType}
                            defaultValue={holeType}
                            onChange={holeTypeHandleChange}
                          >
                            <MenuItem value={2}>{t("Hole")} </MenuItem>
                            <MenuItem value={3}>{t("Approach")} </MenuItem>
                          </Select>
                        </FormControl>

                        <BtnWrapper>
                          <button onClick={loadFunc}>{t("Load")}</button>
                        </BtnWrapper>
                      </ZoomPreviewData>
                    ) : (
                      <>
                        <p>
                          <span>{t("Preview")} :</span> {t("Hole_No")}{" "}
                          {imageHoleNo.get()}, view
                        </p>
                        <h6>{SiteName && SiteName[0]?.Name}</h6>
                      </>
                    )}
                  </div>
                  <div className="icon-section">
                    <Tooltip title="Zoom preview image" arrow>
                      <button
                        className="zoombtn"
                        onClick={(e) => {
                          setImageZoom(!imageZoom)
                          isPreviewImageZoomed.set(!isPreviewImageZoomed.get())
                        }}
                      >
                        {imageZoom ? (
                          <ZoomOutIcon
                            color="var(--text-secondary)"
                            width={14}
                            height={14}
                          />
                        ) : (
                          <ZoomIcon
                            color="var(--text-secondary)"
                            width={14}
                            height={14}
                          />
                        )}
                      </button>
                    </Tooltip>
                    <Tooltip title={t("Refresh_preview_image")} arrow>
                      <button className="zoombtn" onClick={reloadFunc}>
                        <RefreshIcon color="var(--text-secondary)" />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </Preview>
            ) : null}
          </div>
          {imageUrl.get() && imageUrl.get() !== undefined ? (
            <>
              {" "}
              {mapInformationStatus == "request" ? (
                <CenterLoader>
                  {" "}
                  <CircularProgress size={30} />
                </CenterLoader>
              ) : (
                <>
                  <PreviewImgWrapper
                    style={{ height: imageZoom ? "auto" : null }}
                  >
                    <LoadPreviewImage mapInformationData={mapInformationData} siteSetupData={siteSetupData} />
                  </PreviewImgWrapper>
                </>
              )}
            </>
          ) : mapInformationData === null ? (
            <div>
              <p>Warning! No preview map image available.</p>
            </div>
          ) : imageHoleNo.get() ? (
            <p>Loading..</p>
          ) : null}
          <VerifyPopup
            open={verifyPopupOpen}
            SetVerifyPopupOpen={SetVerifyPopupOpen}
            title={verifyTitle}
            text={verifyText}
          />
        </>
      )}
    </SelectTagCar>
  );
};
const PreviewImgWrapper = styled.div`
  display: flex;
  border: 1px solid #000000;
  border-radius: 0px 0px 5px 5px;
  height: 171px;
  img {
    width: 100%;
    height: 100%;
  }
`;
const Preview = styled.div`
  padding-top: 7px;
  .text-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    p {
      font-weight: 600;
      font-size: 13px;
      line-height: 15px;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      color: var(--text-primary);
      span {
        color: var(--text-secondary);
      }
    }
    .zoombtn {
      background: transparent;
      border: none;
      padding: 0;
    }
    h6 {
      font-weight: 600;
      font-size: 13px;
      line-height: 150.5%;
      color: var(--text-primary);
    }
    .icon-section {
      display: flex;
      gap: 16px;
    }
  }
`;
const VerifySiteSetup = styled.div`
  display: flex;
  justify-content: center;
  padding: 6px 0 0px;
  border-bottom: 1px solid var(--section-border-color);
  button {
    font-size: 13px;
    line-height: 150.5%;
    /* width: 208px; */
    text-transform: initial;
    min-height: 30px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    background-color: transparent;
    border: 1px solid var(--border-color);
    color: var(--text-primary);
    border-radius: 30px;
    :hover {
      border: 1px solid var(--border-color);
    }
  }
`;
const SendData = styled.div`
  padding: 0px 0;
  display: flex;
  gap: 9px;
  flex-direction: column;
  .send-heading {
    color: var(--text-primary);
    padding-top: 4px;
    font-weight: 600;
    font-size: 16px;
    line-height: 150.5%;
  }
  .data-btn-wrapper {
    display: flex;
    gap: 9px;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  button {
    display: flex;
    align-items: center;
    gap: 7px;
    justify-content: center;
    &.publish-car {
      width: 100%;
    }
    text-transform: initial;

    &.send-data-btn {
      background: var(--theme-background);
      border: none;
      border-radius: 6px;
      color: var(--theme-text);
      font-size: 13px;
      line-height: 150.5%;
      height: 30px;
      padding: 0 6px;
    }
    &.deactive {
      background: #837f7f;
    }
  }
`;
const HoleNumber = styled.div`
  > div {
    display: flex;
    align-items: center;
    gap: 11px 6px;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--section-border-color);
    button {
      background: transparent;
      width: 24px;
      height: 24px;
      font-size: 12px;
      line-height: 14px;
      font-family: "latomedium";
      border-radius: 50%;
      background: var(--theme-text);
      border: 1px solid var(--club-car-gold-bg);
      color: #176c81;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        background: var(--theme-background);
        border: 1px solid var(--club-car-gold-bg);
        color: var(--theme-text);
      }
    }
  }

  > p {
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    color: var(--text-primary);
    margin-bottom: 5px;
    padding-top: 0px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }
`;
const Container = styled.div`
  max-height: calc(100vh - 130px);
  overflow: auto;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid #707374;
  border-radius: 6px;
  position: absolute;
  width: 298px;
  right: 0;
  transform: translate(calc(100vw - 536px), 0);
  /* height: 100%; */
  top: 64px;
  > .all-data {
    position: relative;

    padding: 42px 13px 13px;
    .close-icon {
      position: absolute;
      right: 14px;
      top: 14px;
      cursor: pointer;
    }
    .heading {
      color: #82dbcf;
      font-weight: 600;
      font-size: 16px;
      line-height: 150.5%;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      padding-bottom: 6px;
      border-bottom: 1px solid var(--section-border-color);
      position: relative;
      ::after {
        content: "";
        display: inline-flex;
        position: absolute;
        height: 2px;
        width: 93px;
        background-color: #82dbcf;
        bottom: -1px;
        left: 0;
        z-index: 1;
      }
    }
    .filter-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 5px;
      padding: 15px 0;
      border-bottom: 1px solid var(--section-border-color);

      button {
        background: #4c4a4a;
        border: 1px solid #707374;
        border-radius: 6px;
        width: 45px;
        height: 30px;
        color: #fff;
        font-size: 13px;
        line-height: 150.5%;
        font-family: "latomedium";
        &.selected {
          background: #00a692;
          border: 1px solid #00a692;
        }
      }
    }
  }
`;

const Holes = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--text-primary);
  border-bottom: 1px solid var(--section-border-color);
  padding: 0px 0;
  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 150.5%;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }
  .MuiFormGroup-row {
    gap: 15px;
  }
  .MuiFormControlLabel-label {
    font-size: 13px;
  }
  .MuiSvgIcon-root {
    color: #fff;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
`;

const ZoomPreviewData = styled.div`
  /* background-color: #fff; */
  display: flex;
  gap: 10px;
  align-items: center;
  padding-right: 10px;
  .MuiFormControl-root {
    max-width: 184px;
  }
  .MuiSelect-select {
    padding: 3.5px 14px;
    font-size: 13px;
    background-color: var(--input-background);
    border: 1px solid var(--border-color);
    border-radius: 6px;
    color: var(--text-primary);
  }
  button {
    background: transparent;
    border: 1px solid #fff;
    font-size: 13px;
    color: #fff;
    width: 58px;
    border-radius: 27px;
    height: 28px;
  }
  /* .MuiInputBase-root {
    border: 1px solid #707374;
    border-radius: 6px;
  } */
`;
const CenterLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
`;
export const BtnWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  border-bottom: 1px solid var(--section-border-color);
  button {
    border: 1px solid var(--border-color);
    border-radius: 6px;
    justify-content: center;
    font-size: 13px;
    line-height: 150.5%;
    font-weight: 400;
    color: var(--text-primary);
    text-transform: initial;
    background-color: var(--input-background);
    min-height: 30px;
    display: flex;
    align-items: center;
    gap: 10px;
    &.active {
      border-color: var(--theme-background);
      color: var(--theme-text);
      background-color: var(--theme-background);
    }
  }
`;
